import { Suspense } from 'react';
import GlobalLoader from 'src/newSrc2/components/GlobalLoader/index';
import { getScreenComponent } from '../screenMappingConfig';
import { connect } from 'react-redux';

const DynamicScreen = props => {
  const { userInfo, screenComponentName } = props;
  const ScreenComponent = getScreenComponent(
    userInfo?.company_text_id,
    screenComponentName
  );

  return (
    <Suspense fallback={<GlobalLoader loading={true} />}>
      <ScreenComponent />
    </Suspense>
  );
};

const mapStateToProps = state => ({
  userInfo: state.authentication.userInfo,
});

export default connect(mapStateToProps)(DynamicScreen);
